import React, { useEffect, useState } from 'react'
import QuestionSection from '../Questions/QuestionSection'
import InterviewSession from '../Questions/InterviewSession'

function Questions() {
  return (
   <>
    <InterviewSession />
   </>
  )
}

export default Questions
